import classes from './Transport.module.sass'
import { Button } from '../../common/components/button/Button'
import { Sort } from '../../common/components/sort/Sort'
import { TransportList } from './components/transportList/TransportList'
import { useTransport } from './hooks/useTransport'
import { Filters } from '../../common/components/filters/Filters'
import { SearchSelectFilter } from '../../common/components/listControl/searchSelectFilter/SearchSelectFilter'
import Search from '../../common/components/listControl/search/Search'
import { Helmet } from 'react-helmet-async'
import { GMapForMarkers } from '../../common/components/maps/gMapForMarkers/GMapForMarkers'
import { orderStatusOptions } from '../../common/utils/constants'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../store/slices/currentUserSlice'
import { ListPageType } from '../../common/types/enums'
import TransportTypeSelector from '../../common/components/listControl/transportTypeSelector/TransportTypeSelector'

export const Transport = () => {
  const {
    list,
    addAction,
    createCitySelectList,
    onChangeSearch,
    onChangeSort,
    clearSearch,
    sortOptions,
    setCity,
    sort,
    search,
    filtersDirty,
    cityId,
    clearFilters,
    activateFilters,
    setStatus,
    status,
    toggleSelected,
    pageType,
    loading,
    types,
    setTypes,
    filtersChanged,
  } = useTransport()

  const currentUser = useSelector(selectCurrentUser)

  return (
    <div className={classes.Container}>
      <Helmet>
        <title>logid - транспорт</title>
        <meta name="description" content="Найти транспорт от курьера до фуры по всей России" />
      </Helmet>
      <div className={classes.Header}>
        {pageType === ListPageType.MY
          ? 'Мой транспорт'
          : pageType === ListPageType.SELECTED
          ? 'Избранный транспорт'
          : 'Транспорт'}
      </div>
      <div className={classes.ButtonAndFilters}>
        <div className={classes.ButtonContainer}>
          <Button text="Добавить транспорт" onClick={addAction} />
        </div>
        <div className={classes.SearchFilterSortContainer}>
          <Filters
            clearFilters={clearFilters}
            filtersDirty={filtersDirty}
            activateFilters={activateFilters}
            filtersChanged={filtersChanged}
          >
            {/* <DateFilter onChange={onChangeRange} range={range} /> */}
            <SearchSelectFilter
              visibleOptionsLength={10}
              emptyPlaceHolder="Начните ввод, чтобы найти и выбрать город"
              options={createCitySelectList()}
              onChangeHandler={setCity}
              value={cityId}
              placeholder={createCitySelectList().length > 0 ? 'Все города' : 'Нет городов'}
            />

            {currentUser && pageType === 'my' ? (
              <SearchSelectFilter
                emptyPlaceHolder="Начните ввод, чтобы найти и выбрать статус"
                options={[
                  {
                    id: '',
                    name: 'Все статусы',
                    label: 'Все статусы',
                    value: '',
                  },
                  ...orderStatusOptions,
                ]}
                onChangeHandler={setStatus}
                value={status}
                placeholder={'Все статусы'}
                visibleOptionsLength={9}
              />
            ) : (
              <></>
            )}

            <TransportTypeSelector multiple topData={types} setTopData={setTypes} />
          </Filters>
          <Sort
            options={sortOptions}
            value={sort}
            onChange={onChangeSort}
            activateFilters={activateFilters}
          />
          <div className={classes.SearchContainer}>
            <Search
              onChange={onChangeSearch}
              clear={clearSearch}
              value={search}
              placeHolder="Введите наименование или описание"
            />
          </div>
        </div>
      </div>

      {list.data.length > 0 ? (
        <TransportList list={list.data} toggleSelected={toggleSelected} loading={loading} />
      ) : !filtersDirty ? (
        <div className={classes.Message}>Транспорт не найден, проверьте фильтры</div>
      ) : (
        <div className={classes.Message}>Нет транспорта</div>
      )}

      <GMapForMarkers list={list.data} />
    </div>
  )
}
